'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidHappy = function IoAndroidHappy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.3 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.4-16.3-16.3 7.3-16.2 16.3-16.2z m0 29.2c7.1 0 12.9-5.8 12.9-13s-5.8-13-12.9-13-13 5.8-13 13 5.8 13 13 13z m5.7-14.6c-1.5 0-2.5-1.1-2.5-2.5s1-2.4 2.5-2.4 2.4 1 2.4 2.4-1 2.5-2.4 2.5z m-11.5 0c-1.4 0-2.4-1.1-2.4-2.5s1-2.4 2.4-2.4 2.5 1 2.5 2.4-1 2.5-2.5 2.5z m5.8 10.5c-3.9 0-7-2.3-8.3-5.6h16.5c-1.3 3.3-4.4 5.6-8.2 5.6z' })
        )
    );
};

exports.default = IoAndroidHappy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-happy.js
// module id = 2103
// module chunks = 0